module.exports = __webpack_public_path__ + "static/media/hg5.ebbb6ea2.jpg";